import { Box, Checkbox, FormControlLabel, Grid2, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import PurchasedCourseCard from '../../shared/components/student/PurchasedCourseCard'
import CustomDivider from '../../shared/utils/CustomDivider'
import SelectBoxField from '../../shared/components/formfields/SelectBoxField'
import { Grid_Gap } from '../../shared/constants'
import { useCourseCategory, } from '../../assets/api/UseStudentGetApi'
import { SkeletonCom } from '../../shared/utils/SkeletonCom'
import { GridChildren } from '../../shared/utils/LingtBlueContainer'
import useAuthStore from '../../store/useAuthStore'
import ToggleSwitch from '../../shared/utils/CustomToggle'
import { useProcessedCourses } from '../../shared/hook/useProcessedCourses'

const Explore = () => {
  const [showActiveOnly, setShowActiveOnly] = useState(false);
  const { user } = useAuthStore();
  const [filter, setFilter] = useState({});
  useEffect(() => {
    setFilter((prevFilter) => {
      const newFilter = { ...prevFilter };
      if (showActiveOnly) {
        newFilter.online = 1;
      } else {
        delete newFilter.online;
      }
      return newFilter;
    });
  }, [showActiveOnly]);
  const [checked, setChecked] = useState(false);
  const { data: courseCategory, isLoading: isLoadingCategoryList } = useCourseCategory();
  const CategoryOptions = courseCategory?.data?.map((category) => ({
    id: category?.id,
    label: category?.name,
    value: category?.name,
  })) || []
  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    if (isChecked) {
      setFilter(prev => ({ ...prev, apartment_id: user?.apartment_id }));
    } else {
      setFilter(prev => {
        const newFilter = { ...prev };
        delete newFilter.apartment_id;
        return newFilter;
      });
    }
  };

  const handleCategoryChange = (value) => {
    setFilter(prev => ({ ...prev, category_id: value }));
  };

  const handleClearCategory = () => {
    setFilter(prev => {
      const newFilter = { ...prev };
      delete newFilter.category_id;
      return newFilter;
    });
  };


  const handleToggleChange = (isChecked) => {
    setShowActiveOnly(isChecked);
  };

  const {  normalCourses:courses, isLoading } = useProcessedCourses(filter)

  // const excludedTypes = [5, 8];
  // const courses = data?.filter(course => !excludedTypes?.includes(course?.type)) || [];


  return (
    <Box>

      <CustomDivider orientation='horizontal' />

      <NormalContainerWithHeader headerText={"Explore Courses"} RightContent={
        <Grid2
          container
          spacing={Grid_Gap}
          width={"100%"}
          justifyContent="flex-end"
        >

          <ToggleSwitch checked={showActiveOnly} onCheck={handleToggleChange} checkedText={"Online"} unCheckedText={"Online"} />
          <Grid2 children size={{ lg: 4, xs: 6 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checked}
                  onChange={handleCheckboxChange}
                  sx={{
                    color: "#000",
                    "&.Mui-checked": { color: "#000" },
                    transform: "scale(1)"
                  }}
                />
              }
              label="Show My Apartment Courses"
            />
          </Grid2>
          <Grid2 children size={{ lg: 4, xs: 6 }} >

            <SelectBoxField
              label="Course Category"
              options={CategoryOptions}
              isRequired={true}
              onChange={handleCategoryChange}
              ClearFunc={handleClearCategory}
              isloading={isLoadingCategoryList}
            />
          </Grid2>
        </Grid2>}>
        <Grid2 container spacing={Grid_Gap}>
          {isLoading ? (
            [...Array(9)].map((_, index) => (
              <GridChildren index={index} key={index}>
                <SkeletonCom />
              </GridChildren>
            ))
          ) : courses?.length === 0 ? (
            <Box textAlign="center" width="100%">
              <Typography>Course not found.</Typography>
            </Box>
          ) : (
            courses.map((item, index) => (
              <GridChildren index={index} key={index}>
                <PurchasedCourseCard item={item} />
              </GridChildren>
            ))
          )}
        </Grid2>
      </NormalContainerWithHeader>
    </Box>
  )
}

export default Explore